import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import {
    Modal,
    Card,
    CardContent,
    CardActions,
    Grid,
    Typography,
    TextField,
    Switch,
    CardHeader,
    Divider,
    Button,
    colors
} from '@material-ui/core';
import { edit_showroom_operator, edit_showroom } from '../../api/API';

const useStyles = makeStyles(theme => ({
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        outline: 'none',
        boxShadow: theme.shadows[20],
        width: 700,
        maxHeight: '100%',
        overflowY: 'auto',
        maxWidth: '100%'
    },

    container: {
        marginTop: theme.spacing(3)
    },

    actions: {
        justifyContent: 'flex-end'
    },

    // saveButton: {
    //     color: theme.palette.white,
    //     backgroundColor: colors.green[600],
    //     '&:hover': {
    //         backgroundColor: colors.green[900]
    //     }
    // },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
}));

export default function EditShowroomOperator(props) {

    const { open, onClose, customer, className, ...rest } = props;

    const classes = useStyles();

    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');

    const [formState, setFormState] = useState({
        showroom_operator_id: props.admins.showroom_operator_id,
        email: props.admins.email,
        contact: props.admins.contact,
        name: props.admins.name,
        password: "",
        password2: ""
    });

    if (!open) {
        return null;
    }

    const handleFieldChange = event => {
        event.persist();
        setFormState(formState => ({
            ...formState,
            [event.target.name]:
                event.target.type === 'checkbox'
                    ? event.target.checked
                    : event.target.value
        }));
    };

    const handleSubmit = async event => {
        event.preventDefault();

        let submit_data = {
            ...formState,
        }
        if(password != '' ){
            if(password != password2){
                alert("Passwords do not match");
                return;
            }else{
                submit_data['password'] = password;
                submit_data['password2'] = password2;
            }
        }
        let data = await edit_showroom_operator(submit_data);
        if(data){
            onClose();
        }else{
            alert(data.message);
        }
        
    };

    return (
        <Modal
            onClose={onClose}
            open={open}
        >
            <Card
                {...rest}
                className={" edit_modal"}
            >
                <CardHeader title="Edit Operator Detail"></CardHeader>
                <Divider></Divider>
                <form onSubmit={handleSubmit}>
                    <CardContent>
                       
                        <Grid
                            className={classes.container}
                            container
                            spacing={3}
                        >
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Name"
                                    name="name"
                                    onChange={handleFieldChange}
                                    value={formState.name}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Email"
                                    name="email"
                                    onChange={handleFieldChange}
                                    value={formState.email}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Contact Number"
                                    name="contact"
                                    onChange={handleFieldChange}
                                    value={formState.contact}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Password"
                                    name="password"
                                    onChange={(e)=>{setPassword(e.target.value)}}
                                    type="password"
                                    value={password}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Confirm Password"
                                    name="password"
                                    onChange={(e)=>{setPassword2(e.target.value)}}
                                    type="password"
                                    value={password2}
                                    variant="outlined"
                                />
                            </Grid>




                        </Grid>
                    </CardContent>
                    <CardActions className={classes.actions}>
                        <Button
                            style={{
                                backgroundColor: "black"
                            }}
                            onClick={onClose}
                            variant="contained"
                        >
                            <CloseIcon className={classes.leftIcon} />
                    Close
                    </Button>
                        <Button
                            // className={classes.saveButton}
                            type="submit"
                            variant="contained"
                        >
                            <SaveIcon className={classes.leftIcon} />
                    Save
                    </Button>
                    </CardActions>
                </form>
            </Card>
        </Modal>
    )
}
